import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { useState, useEffect } from "react";

const LocationPicker = ({ selectedAddress, setSelectedAddress }) => {
    // ✅ Load Google Maps with your API key
    const { isLoaded } = useLoadScript({
        googleMapsApiKey: "AIzaSyCf7bYn7iDIs2T6-sDnmr7qWy9oFZOPOuc",
    });

    const [position, setPosition] = useState({ lat: 20.5937, lng: 78.9629 }); // default India

    // ✅ Get current location on load
    useEffect(() => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const lat = pos.coords.latitude;
                    const lng = pos.coords.longitude;
                    setPosition({ lat, lng });
                    setSelectedAddress((prev) => ({
                        ...prev,
                        latitude: lat,
                        longitude: lng,
                    }));
                },
                (err) => console.error("Geolocation error:", err)
            );
        }
    }, [setSelectedAddress]);

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <GoogleMap
            center={position}
            zoom={13}
            mapContainerStyle={{ width: "100%", height: "400px" }}
            onClick={(e) => {
                const lat = e.latLng.lat();
                const lng = e.latLng.lng();
                setPosition({ lat, lng });
                setSelectedAddress((prev) => ({ ...prev, latitude: lat, longitude: lng }));
            }}
        >
            {/* Marker on the selected/current position */}
            <Marker position={position} />
        </GoogleMap>
    );
};

export default LocationPicker;
